import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["GuidesIndexClient"] */ "/vercel/path0/src/app/(default)/guides/GuidesIndexClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopNavBar"] */ "/vercel/path0/src/components/TopNavBar.tsx");
